import { Collection } from "shared/Collection.js";
import { CompanyModel } from "shared/models/CompanyModel.js";

export class CompanyCollection extends Collection {
  get Model() {
    return CompanyModel;
  }
}
